<template >
  <v-app>
    <v-app-bar color="black">
      <div class="bar">
        <div class="logo accent-text no-select">
          <span class="">pic</span>
          <span class="">bun</span>
        </div>
      </div>

      <v-spacer></v-spacer>

      <v-btn class="upload-button">
        <span>Upload</span>
      </v-btn>
    </v-app-bar>

    <v-main>
      <discover/>
    </v-main>
  </v-app>
</template>

<script>
import Discover from './pages/discover.vue';
export default {
  name: "App",

  components: {
    Discover
  },

  data: () => ({
    //
  }),
};
</script>

<style>
.black-background {
  background-color: #000;
}
@font-face {
    font-family: "Comfortaa";
    src: url("./assets/fonts/Comfortaa-Bold.ttf") format('truetype');
    font-weight: 800;
    font-style: bold;
}

.comfortaa {
    font-family: "Comfortaa", cursive;
}
.light-accent-text {
  background: linear-gradient(-90deg, rgb(101, 148, 219) 5%, rgb(255, 255, 255) 60%, rgb(255, 255, 255) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.accent-text {
  background: linear-gradient(-90deg,  rgb(5, 247, 126) 0%, rgb(0, 180, 255) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.no-select {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
</style>



<style scoped>
.logo {
  font-family: "Comfortaa", cursive;
  font-size: 1.8rem;
  font-weight: 100;
  cursor: pointer;
}

.upload-button {
    color: white;
    background: #3A1C71;
    background: -webkit-linear-gradient(-60deg,  rgb(5, 247, 126) 0%, rgb(0, 89, 255) 100%);
    background: linear-gradient(-60deg,  rgb(5, 247, 126) 0%, rgb(0, 89, 255) 100%);
}
</style>
